class CarAsset {
    constructor(id, chassis, motor, patent) {
        this.assetId = id
        this.chassis = chassis
        this.motor = motor
        this.patent = patent
    }

    static fromJson({ id, chassis, motor, patent }) {
        return new CarAsset(id, chassis, motor, patent)
    }
}

export default CarAsset
